export const noAuthURIs = ["jsonapi/taxonomy_term/login_blacklist", "/assets/"];
